module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/notification-2-92a750ffa9bcbd0680bc2de43302a83e.svg";